import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from '@chakra-ui/react'
import type { ReactElement } from 'react'
import type { CMFieldProps } from '.'

const CMTextField = ({
  cmField,
  disabled,
  form,
}: CMFieldProps): ReactElement => (
  <FormControl
    isInvalid={Boolean(
      form.errors?.upload &&
        form.errors?.upload[cmField.name] 
    )}
    isRequired={cmField.schema.isValueRequired}
    isDisabled={disabled}
  >
    <FormLabel>{cmField.label}</FormLabel>
    <Input
      type="text"
      value={form?.values?.upload[cmField.name] || ''}
      disabled={disabled}
      readOnly={disabled}
      onChange={e => {
        const value = e.target.value
        if (value.length === 0) {
          form.setFieldValue(`upload.['${cmField.name}']`, null)
        } else {
          form.setFieldValue(`upload.['${cmField.name}']`, value)
        }
      }}
    />
    <FormErrorMessage>
      {form.errors?.upload && form.errors?.upload[cmField.name]}
    </FormErrorMessage>
  </FormControl>
)

export default CMTextField
